import React from "react";
import { Grid } from "@mui/material";
import NewsHeadlines from "./NewsHeadlines";
import useShopWebsiteCustomization from "./ShopWebsiteCustomization.hook";
import CateringTypes from "./CateringTypes";
import ThirdPartyDeliveryOptions from "./ThirdPartyDeliveryOptions";
import SocialNetworkingLinks from "./SocialNetworkingLinks";
import JobApplicationProcess from "./JobApplicationProcess";
import WebSiteCustomationShimmer from "./WebSiteCustomationShimmer";
import Sweepstakes from "./Sweepstakes";
const ShopWebsiteCustomization = () => {
  const shopWebsiteCustomization = useShopWebsiteCustomization();

  return (
    <>
      <div className="pt-6 mt-16 mx-auto max-w-7xl min-w-[28rem] px-4">
        <header>
          <div className="flex flex-wrap justify-between items-center ">
            <div>
              <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                Shop Website Customization
              </h1>
            </div>
            <div className="flex justify-end">
              <p className="text-md pt-2">
                <b className="text-[#D41042]">URL</b> -
                <a
                  href={shopWebsiteCustomization?.shopUrl}
                  target="_blank"
                  className="underline text-[#002EA5]"
                >
                  {shopWebsiteCustomization?.shopUrl}
                </a>
              </p>
            </div>
          </div>
        </header>
        <main>
          {shopWebsiteCustomization?.loading ? (
            <>
              <Grid container spacing={2} paddingTop={"14px"}>
                <Grid item xs={12} md={8}>
                  <WebSiteCustomationShimmer />
                </Grid>
                <Grid item xs={12} md={4}>
                  <WebSiteCustomationShimmer />
                </Grid>
                <Grid item xs={12} md={8}>
                  <WebSiteCustomationShimmer />
                </Grid>
                <Grid item xs={12} md={4}>
                  <WebSiteCustomationShimmer />
                </Grid>
                <Grid item xs={12} md={12}>
                  <WebSiteCustomationShimmer />
                </Grid>
                <Grid item xs={12} md={12}>
                  <WebSiteCustomationShimmer />
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid container spacing={2} paddingTop={"14px"}>
                <Grid item sm={12} md={8}>
                  <NewsHeadlines
                    shopWebsiteCustomization={shopWebsiteCustomization}
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <CateringTypes
                    shopWebsiteCustomization={shopWebsiteCustomization}
                  />
                </Grid>
                <Grid item sm={12} md={8}>
                  <ThirdPartyDeliveryOptions
                    shopWebsiteCustomization={shopWebsiteCustomization}
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <SocialNetworkingLinks
                    shopWebsiteCustomization={shopWebsiteCustomization}
                  />
                </Grid>
                <Grid item sm={12} md={12}>
                  <JobApplicationProcess
                    shopWebsiteCustomization={shopWebsiteCustomization}
                  />
                </Grid>
                <Grid item sm={12} md={12}>
                  {shopWebsiteCustomization?.isAdmin ? (
                    <Sweepstakes
                      shopWebsiteCustomization={shopWebsiteCustomization}
                    />
                  ) : null}
                </Grid>
              </Grid>
              {/* <Forms shopWebsiteCustomization={shopWebsiteCustomization} /> */}
            </>
          )}
        </main>
      </div>
    </>
  );
};

export default ShopWebsiteCustomization;
